import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '@/api/type/commonTypes';
import { GetOrderListRequest, GetOrderListResponse } from '../type/types';

// 완료된 주문 목록 조회
export const getCompletedOrderList = async (params: GetOrderListRequest) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const res = await api.get<ApiResponseType<GetOrderListResponse>>(
    `/api/web/partners/orders/search/completed`,
    { params: query }
  );
  return res.data;
};
